import styled from "styled-components";
import { IContainerProps, ITextProps } from "./types";


export const Container = styled.div<IContainerProps>`
  width: fit-content;
  padding: 6px;
  border-radius: 10px;
  margin: 0 auto;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-color: ${({ borderColor }) => borderColor};
  border-width: ${({ borderWidth }) => borderWidth};
  border-style: ${({ borderStyle }) => borderStyle};
  border-radius: ${({ borderRadius }) => borderRadius};
  padding: ${({ padding }) => padding};
`;

export const Text = styled.span<ITextProps>`
  color: ${({ color }) => color};
  font-weight: ${({ fontWeight }) => fontWeight};
  font-size: ${({ fontSize }) => fontSize};
`;
